import $ from 'jquery';
import dom from './dom';

const ACTIVE = 'active';
const SUBACTIVE = 'subactive';
const nav = () => {
  const subnavToggle = $('[data-subnav] .c-main-nav__open-close');
  const mainNavWrapper = $('.c-main-nav__wrapper');
  const isFullNav = $('.home, .category-planning');
  let isSubnavActive = true;
  if (isFullNav && isFullNav.length) {
    if (dom.$win.width() > 1239) {
      isSubnavActive = false;
    } else {
      isSubnavActive = true;
    }
  }
  if (subnavToggle && subnavToggle.length && isSubnavActive) {
    subnavToggle.on('click', ev => {
      ev.preventDefault();
      let $self = $(ev.target);
      if (!$self.hasClass('c-main-nav__link')) {
        $self = $self.closest('.c-main-nav__link');
      }
      if (!$self.hasClass(ACTIVE)) {
        subnavToggle.removeClass(ACTIVE);
        $self.addClass(ACTIVE);
        mainNavWrapper.addClass(SUBACTIVE);
      } else {
        $self.removeClass(ACTIVE);
        mainNavWrapper.removeClass(SUBACTIVE);
      }
    });
    dom.$doc.on('closeNav', () => {
      mainNavWrapper.removeClass(SUBACTIVE);
    });
  }
  const subnavClose = $('[data-subnav-close]');
  if (subnavClose && subnavClose.length) {
    subnavClose.on('click', ev => {
      ev.preventDefault();
      subnavToggle.removeClass(ACTIVE);
      mainNavWrapper.removeClass(SUBACTIVE);
    });
  }
};
export default nav;



// WEBPACK FOOTER //
// ./src/scripts/modules/nav.js